function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, func, bool, number, oneOf } from 'prop-types';
import classNames from 'classnames';
import './InputStepper.scss';
import Button from '../../Button/Button';
import uuid from 'uuid';
import Input from '../Input/Input';
import Label from '../Label/Label';
import { PlusIcon, TriangleLeftIcon, TriangleRightIcon } from '@ruter-ds/rds-icons';
var propTypes = {
  value: string.isRequired,

  /** Callback function from increase button to add to the value */
  increaseValue: func.isRequired,

  /** Callback function from decrease button to remove from the value */
  decreaseValue: func.isRequired,

  /** Label text*/
  label: string.isRequired,

  /** Hidden text on the increase button to make it accessible for screen readers */
  increaseButtonText: string,

  /** Hidden text on the decrease button to make it accessible for screen readers */
  decreaseButtonText: string,

  /** A function that fires when the input is changed */
  onValueChange: func,

  /** A function that fires when the input gets focus */
  onInputFocus: func,

  /** A function that fires when the input looses focus */
  onInputBlur: func,

  /** Set the size of the stepper. */
  size: oneOf(['small', 'medium', 'large']),

  /** Custom classes added to the rds-stepper */
  className: string,

  /** Hide the label */
  hideLabel: bool,

  /** Disable the component */
  disabled: bool,

  /** Visual presentation of an error */
  hasError: bool,

  /** Read only */
  readOnly: bool,

  /** The minimum allowable number. Decrease button will be disabled when min number is reached.   */
  min: number,

  /** The maximum allowable number. Increase button will be disabled when max number is reached.  */
  max: number
};
var defaultProps = {
  value: 0,
  increaseValue: function increaseValue() {},
  decreaseValue: function decreaseValue() {},
  onValueChange: function onValueChange() {},
  onInputFocus: function onInputFocus() {},
  onInputBlur: function onInputBlur() {},
  increaseButtonText: 'Legg til',
  decreaseButtonText: 'Trekk fra',
  readOnly: false,
  hideLabel: false,
  size: 'medium'
};
/** The InputStepper component lets users increase or decrease values by clicking buttons. It has the same functionality as the Stepper, but it looks a bit different.
 * @visibleName Input Stepper
 * */

var InputStepper = /*#__PURE__*/function (_Component) {
  _inherits(InputStepper, _Component);

  var _super = _createSuper(InputStepper);

  function InputStepper(props) {
    var _this;

    _classCallCheck(this, InputStepper);

    _this = _super.call(this, props);
    _this.valueId = "rds-input-stepper-value-".concat(uuid.v4());
    return _this;
  }

  _createClass(InputStepper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          increaseValue = _this$props.increaseValue,
          decreaseValue = _this$props.decreaseValue,
          onValueChange = _this$props.onValueChange,
          onInputBlur = _this$props.onInputBlur,
          onInputFocus = _this$props.onInputFocus,
          increaseButtonText = _this$props.increaseButtonText,
          decreaseButtonText = _this$props.decreaseButtonText,
          readOnly = _this$props.readOnly,
          label = _this$props.label,
          hideLabel = _this$props.hideLabel,
          disabled = _this$props.disabled,
          hasError = _this$props.hasError,
          min = _this$props.min,
          max = _this$props.max,
          className = _this$props.className,
          size = _this$props.size;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('rds-input-stepper', {
          'rds-input-stepper--has-error': hasError
        }, className)
      }, /*#__PURE__*/React.createElement(Label, _extends({
        htmlFor: this.valueId,
        labelText: label
      }, hideLabel && {
        hideLabel: hideLabel
      }, {
        className: classNames('rds-input-stepper__label', {
          'rds-input-stepper__label--hidden': hideLabel
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames('rds-input-stepper__controls', {
          'rds-input-stepper__controls--has-error': hasError
        }, className),
        disabled: disabled
      }, /*#__PURE__*/React.createElement(Button, {
        className: "rds-input-stepper__button rds-input-stepper__button--decrease",
        onClick: decreaseValue,
        variant: "flat",
        text: decreaseButtonText,
        iconLeft: /*#__PURE__*/React.createElement(TriangleLeftIcon, null),
        hideText: true,
        "aria-controls": this.valueId,
        disabled: value <= min || disabled || readOnly ? true : false,
        size: size
      }), /*#__PURE__*/React.createElement(Input, {
        className: "rds-input-stepper__value",
        type: "text",
        value: value,
        "aria-live": "assertive",
        onChange: onValueChange,
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        readOnly: readOnly,
        id: this.valueId,
        size: size,
        disabled: disabled
      }), /*#__PURE__*/React.createElement(Button, {
        className: "rds-input-stepper__button rds-input-stepper__button--increase",
        onClick: increaseValue,
        variant: "flat",
        text: increaseButtonText,
        iconLeft: /*#__PURE__*/React.createElement(TriangleRightIcon, null),
        hideText: true,
        "aria-controls": this.valueId,
        disabled: value >= max || disabled || readOnly ? true : false,
        size: size
      })));
    }
  }]);

  return InputStepper;
}(Component);

InputStepper.propTypes = propTypes;
InputStepper.defaultProps = defaultProps;
export default InputStepper;